import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./layout/Layout";
import { LayoutAuth } from "./layout/LayoutAuth";

import { HomePage } from "../pages/homePage/components/homePage";
// import SignIn from "../pages/signIn/SignIn";
import { SignInPage } from "../pages/signIn/components/SignInPage";
import { SignUpPage } from "../pages/signUp/components/SignUpPage";
import { ThankYouPage } from "../pages/signUp/components/ThankYouPage";
import { NotFoundPage } from "../pages/notFound/components/NotFoundPage";
import ProfileSettings from "../modules/ProfileSettings/ProfileSettings";
import Preferences from "../modules/Preferences/Preferences";
import Storage from "../modules/Storage/Storage";
// end guest
import { ViewerPage } from "../pages/viewerPage/ViewerPage";
import FileManager from "../modules/FileManager/FileManager";
// Admin
import { AdminPage } from "../pages/Admin/components/AdminPage";
import { SignInAdmin } from "../modules/Admin/signIn/SignIn";
import Issues from "../modules/Issues/Issues";
import Dashboard from "../modules/Dashboard/Dashboard";

import PrivacyPolicy from "../modules/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "../modules/TermsOfService/TermsOfService";
import Contact from "../modules/Contact/Contact";
import HelpCenter from "../modules/HelpCenter/HelpCenter";
import HelpVideosPage from "../modules/HelpCenter/helpCenter/HelpVideosPage";
import HelpSearchPage from "../modules/HelpCenter/helpCenter/HelpSearchPage";
import HelpCategoryPage from "../modules/HelpCenter/helpCenter/HelpCategoryPage";
import HelpArticlePage from "../modules/HelpCenter/helpCenter/HelpArticlePage";
export const AppRouts = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
      <Route
        path="/HelpCenter/article/:id"
        element={
          <Layout>
            <HelpArticlePage />
          </Layout>
        }
      />
      <Route
        path="/HelpCenter/category/:slug"
        element={
          <Layout>
            <HelpCategoryPage />
          </Layout>
        }
      />
      <Route
        path="/HelpCenter/search"
        element={
          <Layout>
            <HelpSearchPage />
          </Layout>
        }
      />
      <Route
        path="/HelpCenter/videos"
        element={
          <Layout>
            <HelpVideosPage />
          </Layout>
        }
      />
      <Route
        path="/HelpCenter"
        element={
          <Layout>
            <HelpCenter />
          </Layout>
        }
      />

      <Route
        path="/Contact"
        element={
          <Layout>
            <Contact />
          </Layout>
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        }
      />
      <Route
        path="/terms-of-service"
        element={
          <Layout>
            <TermsOfService />
          </Layout>
        }
      />
      <Route
        path="/signin"
        element={
          <Layout>
            <SignInPage />
          </Layout>
        }
      />
      {/* admin page  */}
      <Route
        path="/signin/admin/dev/ArB"
        element={
          <Layout>
            <SignInAdmin />
          </Layout>
        }
      />
      <Route
        path="/signUp"
        element={
          <Layout>
            <SignUpPage />
          </Layout>
        }
      />
      <Route
        path="/thank-you"
        element={
          <Layout>
            <ThankYouPage />
          </Layout>
        }
      />
      <Route
        path="*"
        element={
          <Layout>
            <NotFoundPage />
          </Layout>
        }
      />
      {/* end guest route */}
      <Route
        path="/ViewerPage"
        element={
          <LayoutAuth>
            <ViewerPage />
          </LayoutAuth>
        }
      />
      <Route
        path="/profile-settings"
        element={
          <LayoutAuth>
            <ProfileSettings />
          </LayoutAuth>
        }
      />

      <Route
        path="/Dashboard"
        element={
          <LayoutAuth>
            <Dashboard />
          </LayoutAuth>
        }
      />
      <Route
        path="/Issues"
        element={
          <LayoutAuth>
            <Issues />
          </LayoutAuth>
        }
      />
      <Route
        path="/storage"
        element={
          <LayoutAuth>
            <Storage />
          </LayoutAuth>
        }
      />
      <Route
        path="/Preferences"
        element={
          <LayoutAuth>
            <Preferences />
          </LayoutAuth>
        }
      />
      <Route
        path="/home"
        element={
          <LayoutAuth>
            <FileManager />
          </LayoutAuth>
        }
      />
      {/*Admin page path */}
      <Route
        path="/AdminPage"
        element={
          <LayoutAuth>
            <AdminPage />
          </LayoutAuth>
        }
      />
    </Routes>
  );
};
